export const getNetworkInfo = () => {
  if ("connection" in navigator) {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    return {
      isConnected: navigator.onLine,
      type: connection.type, // e.g., 'wifi', 'cellular'
      effectiveType: connection.effectiveType, // e.g., '4g', '3g'
      downlink: connection.downlink, // Downlink speed in Mbps
    };
  } else {
    return {
      isConnected: navigator.onLine,
      type: "unknown",
      effectiveType: "unknown",
      downlink: "unknown",
    };
  }
};
